import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography, CircularProgress } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SettingsIcon from '@mui/icons-material/Settings';
// import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import PersonIcon from '@mui/icons-material/Person';
import LoginIcon from '@mui/icons-material/Login';
import ListAltIcon from '@mui/icons-material/ListAlt';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from 'react-i18next';

function AppSidebar({ width, isOpen, onClose }) {
  const { t } = useTranslation();
  const location = useLocation();
  const { user, loading } = useAuth();

  const handleItemClick = () => {
    onClose();
  };

  return (
    <Drawer
      variant="temporary"
      open={isOpen}
      onClose={onClose}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
      sx={{
        '& .MuiDrawer-paper': {
          boxSizing: 'border-box',
          width: width,
        },
      }}
    >
      <Box sx={{ p: 2, display: 'flex', alignItems: 'center' }}>
        {/* <FitnessCenterIcon color="primary" sx={{ mr: 1 }} /> */}
        <Typography variant="h6" noWrap component="div" color="primary">
          {t('sidebar.title')}
        </Typography>
      </Box>
      <List>
        <ListItem disablePadding>
          <ListItemButton
            component={Link}
            to="/"
            onClick={handleItemClick}
            selected={location.pathname === '/'}
            sx={{ borderRadius: '0 100px 100px 0' }}
          >
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary={t('sidebar.dashboard')} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            component={Link}
            to="/profile"
            onClick={handleItemClick}
            selected={location.pathname === '/profile'}
            sx={{ borderRadius: '0 100px 100px 0' }}
          >
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText primary={t('sidebar.profile')} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            component={Link}
            to="/presets"
            onClick={handleItemClick}
            selected={location.pathname === '/presets'}
            sx={{ borderRadius: '0 100px 100px 0' }}
          >
            <ListItemIcon>
              <ListAltIcon />
            </ListItemIcon>
            <ListItemText primary={t('sidebar.presets')} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            component={Link}
            to="/settings"
            onClick={handleItemClick}
            selected={location.pathname === '/settings'}
            sx={{ borderRadius: '0 100px 100px 0' }}
          >
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText primary={t('sidebar.settings')} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            component={Link}
            to="/login"
            onClick={handleItemClick}
            selected={location.pathname === '/login'}
            sx={{ borderRadius: '0 100px 100px 0' }}
          >
            <ListItemIcon>
              {loading ? (
                <CircularProgress size={24} />
              ) : user ? (
                <CheckCircleIcon color="success" />
              ) : (
                <LoginIcon />
              )}
            </ListItemIcon>
            <ListItemText primary={loading ? t('sidebar.loading') : user ? t('sidebar.logged_in') : t('sidebar.login')} />
          </ListItemButton>
        </ListItem>
      </List>
    </Drawer>
  );
}

export default AppSidebar;
